import { css } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'

import { useTheme } from '../../theme'
import { isKey } from '../../utils'
import { UiSpacing } from '../../types'

interface IGridProps {
  gap?: UiSpacing | string
  width?: string
  minWidth?: string
  maxWidth?: string
  alignItems?:
    | 'auto'
    | 'normal'
    | 'start'
    | 'end'
    | 'center'
    | 'stretch'
    | 'baseline'
    | 'first baseline'
    | 'last baseline'
  gridTemplateColumns?: string
  component?: string | React.ComponentType<{ ref?: React.RefObject<{}> }>
  children?: React.ReactNode
  innerRef?: React.RefObject<HTMLElement>
}

export const Grid: React.FC<IGridProps> = props => {
  const theme = useTheme()

  const {
    component: Component,
    innerRef,
    gap,
    width,
    minWidth,
    maxWidth,
    alignItems,
    gridTemplateColumns,
    ...rest
  } = props

  if (!Component) {
    return null
  }

  return (
    <Component
      {...css({
        alignItems,
        display: 'grid',
        gridGap: isKey(theme.settings.spacing, gap) ? theme.settings.spacing[gap] : gap,
        gridTemplateColumns:
          gridTemplateColumns || `repeat(auto-fit, minmax(${minWidth || width}, ${maxWidth || '1fr'}))`,
      })}
      ref={innerRef}
      {...rest}
    />
  )
}

Grid.propTypes = {
  gap: PropTypes.string,
  width: PropTypes.string,
  minWidth: PropTypes.string,
  maxWidth: PropTypes.string,
  alignItems: PropTypes.oneOf([
    'auto',
    'normal',
    'start',
    'end',
    'center',
    'stretch',
    'baseline',
    'first baseline',
    'last baseline',
  ]),
  gridTemplateColumns: PropTypes.string,
  component: PropTypes.string,
  children: PropTypes.node,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]) as any,
}

Grid.defaultProps = {
  component: 'div',
  alignItems: 'auto',
  gap: 'large',
  width: 'auto',
}
